import { render, staticRenderFns } from "./SpaceObject.vue?vue&type=template&id=2270d10a&"
import script from "./SpaceObject.vue?vue&type=script&lang=js&"
export * from "./SpaceObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports